export const SHOW_ALERT_SUCCESS = "SHOW_ALERT_SUCCESS";
export const SHOW_ALERT_ERROR = "SHOW_ALERT_ERROR";
export const HIDE_ALERT = "HIDE_ALERT";
